import { Component, Input } from '@angular/core';
import { PersonCertificationWrite } from 'src/app/people/models/personCertificationWrite';

@Component({
  selector: 'certification-snapshot',
  templateUrl: './certification-snapshot.component.html',
})
export class CertificationSnapshotComponent {
  @Input()
  certification: PersonCertificationWrite;
}
